import React from "react";

const FitGauge = ({ fit }) => {
  if (!fit) return null;
  return (
    <div className="abr-fit-hero">
      <div className="abr-fit-num-block">
        <span className="abr-fit-num">{fit.score}</span>
        <span className="abr-fit-out">&thinsp;/ {fit.out}</span>
      </div>
      <div className="abr-fit-meta">
        <div className="abr-fit-lbl">{fit.summaryLabel}</div>
        <div className="abr-fit-head">{fit.headline}</div>
        <div className="abr-fit-sub">{fit.sub}</div>
      </div>
    </div>
  );
};

export default FitGauge;
